import { RootState } from '@store/store';

// Get the applicant talent list.
export const getApplicantTalentList = (state: RootState) => state.employer.lists.applicantTalentList;
